import React from 'react'
import { useLocation } from 'react-router-dom';
import Header from '../Layout/Header'
import NonCarouselBanner from '../UI/Banner/NonCarouselBanner'
import PageBannerImage from '../assets/Images/DoctorConsultPage/Doc-spec-page-banner-1.jpg'
import Image from '../UI/UIComponent/Image';
import Footer from '../Layout/Footer'
import Customdropdown from '../UI/UIComponent/customDropdown/customdropdown';

import './Page-style/doctorconsultationpage.scss'

export default function DoctorConsultationBookingPage() {

  const location = useLocation();
  const { objectData } = location.state;
  console.log(objectData);

  return (
    <>
      <Header pageId={'3'}></Header>
      <section>
        <NonCarouselBanner
          ImageSrc={PageBannerImage}
          imageAlt="RHS doctor consultation"
        ></NonCarouselBanner>
        <div className="container-fluid doctor-consultation-booking">
          <div className="upper-section">
            <div className="doctor-detail-section">
              <div className="d-flex">
                <div className="doctor-image">
                  <Image imageSrc={objectData[0].doctorPhoto} imageClass='img'></Image>
                </div>
                <div className="doctor-details">
                  <div className="doc-name">
                    <h2>{objectData[0].name}</h2>
                  </div>
                  <div className="doc-dept">
                    <p>{objectData[0].doctorDept}</p>
                    <p>{`${objectData[0].experience} Years of Experience`}</p>
                  </div>
                  {/* <div className="doc-degree">{objectData[0].experience}</div> */}
                </div>
              </div>
              {/* <div className="about-doctor">
                <p>
                  Aute labore velit officia sit duis sint sit et. Id tempor
                  mollit aliquip quis duis velit aliqua mollit id in duis. Ad
                  amet irure sint quis amet officia pariatur ea proident do.
                  Irure ex sit aliquip commodo est esse enim elit ea irure.
                  Voluptate id aliquip sit eu amet aliqua tempor excepteur
                  commodo ut qui dolore. Voluptate incididunt id esse duis velit
                  aliquip nostrud ut incididunt aute. Nulla est consectetur
                  aliquip incididunt. Dolor elit duis enim exercitation ex
                  voluptate occaecat quis cillum. Enim commodo commodo do amet
                  veniam id incididunt irure esse. Ipsum enim ullamco duis sit.
                  Lorem sit dolore veniam dolore commodo sit dolor laboris sit
                  officia aliqua. Minim enim dolor labore deserunt aute officia
                  duis labore est nisi non nisi fugiat esse. Minim cillum
                  officia culpa irure irure occaecat amet occaecat in laborum in
                  irure. Cupidatat nisi incididunt elit in duis sint laboris
                  minim. Pariatur minim tempor ullamco consectetur minim aliquip
                  ad occaecat quis cupidatat occaecat cupidatat. Exercitation
                  nulla sint eu nulla nulla consectetur aute culpa ullamco
                  laborum elit est occaecat. Irure deserunt nostrud est eu
                  cillum deserunt laboris amet nisi mollit nisi qui laboris
                  occaecat. Amet minim sunt esse elit voluptate dolor ad velit
                  quis. Consequat ullamco Lorem cupidatat fugiat dolore do in
                  minim irure ex sit. Dolor do laborum cupidatat pariatur
                  incididunt cupidatat exercitation fugiat. Aliqua non labore
                  eiusmod deserunt laborum occaecat occaecat magna. Incididunt
                  nostrud elit ea Lorem adipisicing esse.
                </p>
              </div> */}
            </div>
            <div className="slot-info">
              <div className="filters">
                <Customdropdown></Customdropdown>
              </div>
              <div className="available-slots">
                <p>Book Appointment</p>
                <label>Available Slots</label>
              </div>
              <div className="btn-wrapper">test</div>
            </div>
          </div>
          <div className="lower-section">
            <div className="clinic-info">
              <p>KPC Hospitals | RUBY Hospitals | AMRI Hospitals</p>
            </div>
            <div className="call-to">call: 7894561245</div>
          </div>
        </div>
      </section>
      {/* <Footer></Footer> */}
    </>
  )
}
